import React from 'react';
import { BoxProps, HStack, Image } from '@chakra-ui/react';
import { useWeb3WithDefault } from '../../../hooks/useWeb3WithDefault';
import { useMemo } from 'react';
import { links } from '../../../config/links';
import CustomButton from '../../../iZUMi-UI-toolkit/src/components/Buttons/CustomButton/CustomButton';

type Props = {
    expand?: boolean;
} & BoxProps;

const VeTokenLinkButton: React.FC<Props> = (props) => {
    const { expand, ...rest } = props;
    const { chainId } = useWeb3WithDefault();
    const link = useMemo(() => {
        //const scanUrl = getChain(chainId)?.scanUrl;
        return links.veTokenlink;
    }, [chainId]);

    return (
        <CustomButton
            variant="tertiary"
            w="34px"
            h="34px"
            borderRadius="3px"
            text={
                <HStack w="100%" mx="auto">
                    <Image w="19px" h="19px" src={process.env.PUBLIC_URL + '/assets/tokens/veToken.svg'} ml={expand ? '12px' : '8px'} />
                </HStack>
            }
            onClick={() => {
                window.open(link);
            }}
            {...rest}
        ></CustomButton>
    );
};

export default VeTokenLinkButton;
